import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Testimonios() {
  const testimonios = [{
    name: 'Matías',
    age: 29,
    city: 'Buenos Aires',
    img: 'https://i.pravatar.cc/150?img=11',
    quote: 'Siempre me pusieron de extremo izquierdo y nunca supe aprovechar mi zurda. Con el tomo de técnica entendí todo. Ahora soy el más peligroso del equipo.'
  }, {
    name: 'Rodrigo',
    age: 37,
    city: 'Rosario',
    img: 'https://i.pravatar.cc/150?img=15',
    quote: 'No tenía plata para pagar un profe. Este pack me dio todo lo que necesitaba para explotar mi pierna izquierda y entender el juego de fútbol 5.'
  }, {
    name: 'Sebastián',
    age: 33,
    city: 'Córdoba',
    img: 'https://i.pravatar.cc/150?img=53',
    quote: 'Me sentía estancado hace meses. Apliqué el plan de 30 días y mi zurda ahora es un arma real. Mis compañeros lo notan.'
  }];
  return <section className="py-16 bg-white relative" data-id="element-272">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-273">
        <FadeIn data-id="element-274">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 uppercase text-navy" data-id="element-275">
            Lo que dicen{' '}
            <span className="text-celeste" data-id="element-276">nuestros jugadores</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-277">
          {testimonios.map((test, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-278">
              <div className="bg-lightbg border border-gray-200 p-5 rounded-xl h-full flex flex-col relative shadow-sm hover:shadow-md transition-shadow" data-id="element-279">
                <div className="flex text-gold mb-3" data-id="element-280">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-281" />)}
                </div>
                <p className="text-gray-700 italic mb-4 flex-grow text-sm" data-id="element-282">
                  "{test.quote}"
                </p>
                <div className="flex items-center gap-3 mt-auto pt-3 border-t border-gray-200" data-id="element-283">
                  <img src={test.img} alt={test.name} className="w-10 h-10 rounded-full border-2 border-celeste" data-id="element-284" />
                  <div data-id="element-285">
                    <h4 className="font-bold text-navy" data-id="element-286">
                      {test.name}, {test.age}
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-287">{test.city}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}